export default function getRecipientsCount(wellViewState) {
    return wellViewState && wellViewState.recipients ? wellViewState.recipients.length : 0;
}
//# sourceMappingURL=getRecipientsCount.js.map